/**
 * PD+PD Stories JavaScript
 */

console.log("PD+PD Stories page loaded");
